import RecorderPage_v2 from './RecorderPage_v2'

export default RecorderPage_v2